import styles from '../../styles/Impressum.module.css';

const ImpressumModal = ({ close }) => {
    return (
        <div className={styles.impressumOverlay}>
            <div className={styles.impressumContent}>
                <button className={styles.closeButton} onClick={close}>×</button>
                <h3>Impressum</h3>
                <p><strong>Firmenname:</strong> Ing. Andreas Rudolf GRUBER</p>
                <p><strong>Rechtsform:</strong> n.p.EU Ing. Mst. Andreas Rudolf Martin Gruber</p>
                <p><strong>UID:</strong> ATU81607726</p>
                <p>
                    <strong>Kammer/Verband:</strong>
                    <a href="https://firmen.wko.at/ing-mst-andreas-rudolf-martin-gruber-dreamgarage--ing-andreas-rudolf-gruber/k%C3%A4rnten/?firmaid=c85d019b-e749-4bdc-aa4b-5f47b21de723" target="_blank" rel="noopener noreferrer">
                        https://firmen.wko.at/
                    </a>
                </p>
                <p><strong>Sonstige Aufsichtsbehörde:</strong> Bezirkshauptmannschaft Villach-Land</p>
                <p><strong>Geschäftsführer:</strong> Ing. Andreas Rudolf GRUBER</p>
            </div>
        </div>
    );
};

export default ImpressumModal;